import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import Scroll from 'react-scroll';
import { useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTasks, faTachometer, faPlus, faEye, faPencil, faVideo, faCheckCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'
import { useRecoilState } from 'recoil';

import { topAlertMessageState, topAlertStatusState } from "../../../AppState";
import { putSessionTemplateUpdateAPI } from "../../../API/SessionTemplate";
import { getSessionTemplateDetailAPI } from "../../../API/SessionTemplate";
import FormErrorBox from "../../Reusable/FormErrorBox";
import FormInputField from "../../Reusable/FormInputField";
import FormTextareaField from "../../Reusable/FormTextareaField";
import FormMultiSelectField from "../../Reusable/FormMultiSelectField";
import PageLoadingContent from "../../Reusable/PageLoadingContent";


function SessionTemplateVideoSectionExerciseUpdate() {
    ////
    //// URL parameters.
    ////

    const { id, vsIndex } = useParams()

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [isFetching, setFetching] = useState(false);
    const [forceURL, setForceURL] = useState("");
    const [sessionTemplate, setSessionTemplate] = useState({});
    const [name, setName] = useState();
    const [detail, setDetail] = useState();

    ////
    //// Event handling.
    ////

    const onSubmitClick = (e) => {
        console.log("onSubmitClick: Beginning...");
        const modifiedVideoSection = {
            name: name,
            detail: detail,
        };
        console.log("onSubmitClick: Updating to video sections array...");
        for (let videoSectionIndex in sessionTemplate.videoSections) {
            if (videoSectionIndex === vsIndex) {
                sessionTemplate.videoSections[videoSectionIndex] = modifiedVideoSection;
            }
        }

        console.log("onSubmitClick: Payload:", sessionTemplate);

        console.log("onSubmitClick: Please wait");
        putSessionTemplateUpdateAPI(sessionTemplate, onSessionTemplateUpdateSuccess, onSessionTemplateUpdateError, onSessionTemplateUpdateDone);
    }

    ////
    //// API.
    ////

    function onSessionTemplateDetailSuccess(response){
        console.log("onSessionTemplateDetailSuccess: Starting...");
        console.log("onSessionTemplateDetailSuccess: sessionTemplate data:", response);
        setSessionTemplate(response);

        for (let videoSectionIndex in response.videoSections) {
            if (videoSectionIndex === vsIndex) {
                let videoSection = response.videoSections[videoSectionIndex];

                console.log("Matched Video Section", videoSection);
                setName(videoSection.name);
                setDetail(videoSection.detail);
            }
        }
    }

    function onSessionTemplateDetailError(apiErr) {
        console.log("onSessionTemplateDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateDetailDone() {
        console.log("onSessionTemplateDetailDone: Starting...");
        setFetching(false);
    }

    function onSessionTemplateUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionTemplateUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Video section updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Redirect the user to a new page.
        setForceURL("/session-template/"+response.id+"/video-section/"+vsIndex);
    }

    function onSessionTemplateUpdateError(apiErr) {
        console.log("onSessionTemplateUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateError: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();

        // Reload the session template upon errors.
        setFetching(true);
        getSessionTemplateDetailAPI(
            id,
            onSessionTemplateDetailSuccess,
            onSessionTemplateDetailError,
            onSessionTemplateDetailDone
        );
    }

    function onSessionTemplateUpdateDone() {
        console.log("onSessionTemplateUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            setFetching(true);
            getSessionTemplateDetailAPI(
                id,
                onSessionTemplateDetailSuccess,
                onSessionTemplateDetailError,
                onSessionTemplateDetailDone
            );
        }

        return () => { mounted = false; }
    }, [id]);

    ////
    //// Component rendering.
    ////

    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/session-templates" aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Templates</Link></li>
                            <li class=""><Link to={`/session-template/${id}/video-sections`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details (Video Sections)</Link></li>
                            <li class=""><Link to={`/session-template/${id}/video-section/${vsIndex}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faPencil} />&nbsp;Update</Link></li>
                        </ul>
                    </nav>
                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/session-template/${id}/video-section/${vsIndex}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back Video Section</Link></li>
                        </ul>
                    </nav>

                    {/* Content */}
                    <nav class="box">
                        <p class="title is-4"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section</p>
                        <FormErrorBox errors={errors} />

                        <p class="subtitle is-6">Details</p>

                        {isFetching && <PageLoadingContent displayMessage={"Please wait"} />}

                        {!isFetching && <div class="container">
                            <FormInputField
                                label="Name"
                                name="name"
                                type="text"
                                placeholder="Text input"
                                value={name}
                                errorText={errors && errors.name}
                                helpText=""
                                onChange={(e)=>setName(e.target.value)}
                                isRequired={true}
                                maxWidth="350px"
                            />

                            <FormTextareaField
                                label="Detail"
                                name="detail"
                                type="text"
                                placeholder="Text input"
                                value={detail}
                                errorText={errors && errors.detail}
                                helpText=""
                                onChange={(e)=>setDetail(e.target.value)}
                                isRequired={true}
                                maxWidth="375px"
                            />

                            <div class="columns">
                                <div class="column is-half">
                                    <Link to={`/session-template/${id}/video-section/${vsIndex}`} class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Detail</Link>
                                </div>
                                <div class="column is-half has-text-right">
                                    <button class="button is-primary is-fullwidth-mobile" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                </div>
                            </div>

                        </div>}
                    </nav>
                </section>
            </div>
        </>
    );
}

export default SessionTemplateVideoSectionExerciseUpdate;
